module.exports = __webpack_public_path__ + "static/media/broken-chains.1ce3f03f.svg";